module.exports = __webpack_public_path__ + "img/pro-photo2.3cc97c2b.png";